import { memo } from "react";

import { ARN } from "@aws-sdk/util-arn-parser";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography/Typography";

import { FindingDetails } from "stores/FindingStore";

import DataListItem from "components/DataListItem";

// -----------------------------------------------------------------------------

const ARNDataList = memo(function ARNDataList({
  arn,
  details,
}: ARNDataListProps): JSX.Element {
  return (
    <Stack spacing={0.5} sx={{ width: "100%" }}>
      {arn?.partition !== "aws" ? (
        <DataListItem label="Partition">{arn.partition}</DataListItem>
      ) : null}

      <DataListItem label="Account ID">
        {arn.accountId === ""
          ? details?.asset?.account_id || ""
          : arn?.accountId}
      </DataListItem>

      <DataListItem label="Region">
        {arn.region ? (
          <Typography variant="inherit" sx={{ wordBreak: "break-all" }}>
            {arn.region}
          </Typography>
        ) : (
          <>N/A (This finding impacts the entire account)</>
        )}
      </DataListItem>

      <DataListItem label="Service">
        {arn.service ? (
          <Typography variant="inherit" sx={{ wordBreak: "break-all" }}>
            {arn.service}
          </Typography>
        ) : (
          <>N/A (This finding impacts the entire account)</>
        )}
      </DataListItem>

      <DataListItem label="Resource Name">
        {!arn?.resource || (arn?.resource === "root" && arn?.service === "") ? (
          <>N/A (This finding impacts the entire account)</>
        ) : (
          <Typography variant="inherit" sx={{ wordBreak: "break-all" }}>
            {arn.resource}
          </Typography>
        )}
      </DataListItem>
    </Stack>
  );
});

export default ARNDataList;

// -----------------------------------------------------------------------------

interface ARNDataListProps {
  arn: ARN;
  details?: FindingDetails;
}
